import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Topnav from "../components/Navbars/Topnav";
import OtherTopnav from "../components/Navbars/OtherTopnav";
import MobileNav from "../components/Navbars/MobileNav";

const MainLayout = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const isCart = pathname === "/cart";
  const isCheckout = 
  /^\/checkout\/payment\/[^/]+$/.test(pathname) ||
  pathname === "/checkout/init";
  
  

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {/* Cart page par header hide */}
      {!isCart && !isCheckout && (
        <>
          {isMobile ? (
            <MobileNav />
          ) : isHome ? (
            <Topnav />
          ) : (
            <OtherTopnav />
          )}
        </>
      )}

      {/* Page content */}
      <Outlet />
    </>
  );
};
export default MainLayout;